/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect } from 'react'

// import withBreadcrumbs from 'react-router-breadcrumbs-hoc';

import { SetLayoutBreadcrumbContext, SetLayoutBreadcrumbType } from 'dash/layout/CustomLayout'
import { useRecordContext } from 'react-admin'
import AppState from 'shared/app_state'

type ComponentWithSubheaderProps = {
  component: any
  label?: string
  path: string[]
  id?: string
  location?: any
}

export class ComponentWithSubheader extends React.Component<ComponentWithSubheaderProps> {
  componentDidMount(): void {
    this.setBreadcrumb()
  }

  componentDidUpdate(prevProps): void {
    if (prevProps.location?.pathname != this.props.location?.pathname) this.setBreadcrumb()
  }

  setBreadcrumb = () => {
    const { path, label } = this.props
    if (AppState.getIsAccountView()) {
      const { account } = AppState.getIdentity()
      if (account && account.name) path.unshift(account.name)
    }
    this.context({ path, label })
  }

  render() {
    const { component: Component, label, path, ...rest } = this.props

    return <Component {...rest} />
  }
}
ComponentWithSubheader.contextType = SetLayoutBreadcrumbContext

type ComponentWithDynamicResourceHeaderProps = {
  children?: any
  recordAttrForBreadrumb: string
  transformAttr?: (value: any, record?: any) => any
}

export const ComponentWithDynamicResourceHeader: FC<ComponentWithDynamicResourceHeaderProps> = ({
  children,
  recordAttrForBreadrumb,
  transformAttr,
}) => {
  const context = React.useContext(SetLayoutBreadcrumbContext)

  return (
    <DynamicResourceHeaderUpdaterComponent
      recordAttrForBreadrumb={recordAttrForBreadrumb}
      transformAttr={transformAttr}
      setBreadcrumb={context}
    >
      {children}
    </DynamicResourceHeaderUpdaterComponent>
  )
}

type DynamicResourceHeaderUpdaterComponentProps = ComponentWithDynamicResourceHeaderProps & {
  setBreadcrumb: SetLayoutBreadcrumbType
}

export const DynamicResourceHeaderUpdaterComponent: FC<DynamicResourceHeaderUpdaterComponentProps> = ({
  children,
  recordAttrForBreadrumb,
  setBreadcrumb,
  transformAttr,
  ...props
}) => {
  const record = useRecordContext()
  useEffect(() => {
    if (record?.[recordAttrForBreadrumb]) {
      let label = record[recordAttrForBreadrumb]
      if (transformAttr) label = transformAttr(label, record)
      setBreadcrumb({ label })
    }
  }, [record?.[recordAttrForBreadrumb]])

  return <>{React.cloneElement(children, props)}</>
}

// const routes = [
//   { path: '/users/:userId', breadcrumb: DynamicUserBreadcrumb },
//   { path: '/example', breadcrumb: 'Custom Example' },
// ]

// export const ComponentWithSubheader = ({
//   component: Component,
//   label,
//   ...props
// }: {
//   component: any;
//   label?: string;
// }): JSX.Element => {
//   return withBreadcrumbs()(
//     ({ breadcrumbs, ...rest }: { breadcrumbs: { breadcrumb: React.ReactNode }[]; resource: string }) => {
//       console.log(props);
//       return (
//         <>
//           <div style={{ display: 'flex' }}>
//             {breadcrumbs.map(({ breadcrumb }, i) => (
//               <>
//                 {breadcrumb}
//                 {i != breadcrumbs.length - 1 && <span style={{ marginLeft: 5, marginRight: 5 }}>/</span>}
//               </>
//             ))}
//           </div>
//           <h2>{label}</h2>
//           <Component {...rest} />
//         </>
//       );
//     },
//   )(props);
// };
